import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=68a6f0e8&scoped=true&"
import script from "./SuggestionList.vue?vue&type=script&lang=js&"
export * from "./SuggestionList.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=68a6f0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a6f0e8",
  null
  
)

export default component.exports